import { CharmPoolConfig, IslandPoolConfig, V2PoolConfig } from './implementations'
import { PoolConfig } from './types'

// Factory for Pool Configurations
export const POOL_CONFIGS: Record<string, PoolConfig> = {
  kodiak: new IslandPoolConfig(),
  v2: new V2PoolConfig(),
  charm: new CharmPoolConfig(),
}

export function getPoolConfig(provider: string): PoolConfig {
  const config = POOL_CONFIGS[provider]
  if (!config) {
    throw new Error(`Unsupported pool provider: ${provider}`)
  }
  return config
}

// Helper function for legacy code compatibility
export function getPoolTypeFromProvider(provider: string): string {
  switch (provider) {
    case 'kodiak':
      return 'IslandPool'
    case 'v2':
      return 'V2Pool'
    case 'charm':
      return 'CharmPool'
    default:
      return provider
  }
}

// Re-export everything for convenient importing
export * from './hooks/usePoolConfiguration'
export * from './implementations'
export * from './types'
